module.exports = __webpack_public_path__ + "static/media/play_circle_outlined.c062fd2a.svg";